import authTypes from 'reduxConfig/auth.types';

export function clearError() {
  return { type: authTypes.AUTH_CLEAR_ERROR };
}

export function getUser(userId, claims, email) {
  return { type: authTypes.AUTH_GET_USER, userId, claims, email };
}

export function login(email, password, isNewUser) {
  return {
    type: authTypes.AUTH_LOGIN,
    email,
    password,
    isNewUser
  };
}

export function reauthenticate({ provider, email, password }) {
  return {
    type: authTypes.REAUTHENTICATE,
    provider,
    email,
    password
  };
}

export function clearUser() {
  return { type: authTypes.AUTH_CLEAR_USER };
}

export function resetPassword(email) {
  return { type: authTypes.AUTH_RESET_PASSWORD, email };
}

export function resetPasswordReturn(actionCode, password) {
  return { type: authTypes.AUTH_RESET_PASSWORD_RETURN, actionCode, password };
}

export function actionSendEmailVerification(email) {
  return { type: authTypes.AUTH_SEND_EMAIL_VERIFICATION, email };
}

export function verifyEmailReturn(actionCode) {
  return {
    type: authTypes.AUTH_VERIFY_EMAIL_RETURN,
    actionCode
  };
}

export function recoverEmail(actionCode) {
  return {
    type: authTypes.AUTH_RECOVER_EMAIL,
    actionCode
  };
}

export function setClaims(claims) {
  return {
    type: authTypes.AUTH_SET_CLAIMS,
    claims
  };
}

export function setError(error) {
  return {
    type: authTypes.AUTH_SET_ERROR,
    error
  };
}

export function setIds(userId, accountId) {
  return {
    type: authTypes.AUTH_SET_IDS,
    userId,
    accountId
  };
}

export function startLoading() {
  return { type: authTypes.AUTH_START_LOADING, loading: true };
}

export function stopLoading() {
  return { type: authTypes.AUTH_STOP_LOADING, loading: false };
}

export function setMessage(message = null) {
  return {
    type: authTypes.AUTH_SET_MESSAGE,
    message
  };
}

export function setVerificationTimeOut(timeout) {
  return {
    type: authTypes.AUTH_SET_VERIFICATION_TIME_OUT,
    timeout
  };
}

export function setVerificationEmail(email) {
  return {
    type: authTypes.AUTH_SET_VERIFICATION_EMAIL,
    email
  };
}

export function setStep(step = null) {
  return {
    type: authTypes.AUTH_SET_STEP,
    step
  };
}

export function setUser(user) {
  return {
    type: authTypes.AUTH_SET_USER,
    user
  };
}

export function setVerifiedPhoneNumber(phoneNumber) {
  return {
    type: authTypes.AUTH_SET_PHONE_NUMBER,
    phoneNumber
  };
}

export function signUpWithEmail(email, password, referralCode, cardPartnershipCode) {
  return {
    type: authTypes.AUTH_SIGNUP,
    signupFunction: () => window.FIREBASE.signUp(email, password),
    referralCode,
    cardPartnershipCode
  };
}

export function openIDLoginSignup(signupFunction, referralCode, cardPartnershipCode) {
  return {
    type: authTypes.AUTH_SIGNUP,
    signupFunction,
    referralCode,
    cardPartnershipCode
  };
}

export function verifyEmail() {
  return { type: authTypes.AUTH_VERIFY_EMAIL };
}

export function actionVerifyLogin({
  email,
  idToken,
  twoFactorCode,
  useRecoveryCode,
  forceRefreshIdToken
} = {}) {
  return {
    type: authTypes.AUTH_VERIFY_LOGIN,
    email,
    idToken,
    twoFactorCode,
    useRecoveryCode,
    forceRefreshIdToken
  };
}

export function initFirebaseMfa({ recaptchaContainerId, resolver }) {
  return {
    type: authTypes.FIREBASE_MFA_INIT,
    recaptchaContainerId,
    resolver
  };
}

export function actionVerifyFirebaseMfaSMSCode({ resolver, verificationId, verificationCode }) {
  return {
    type: authTypes.FIREBASE_MFA_VERIFY_CODE,
    resolver,
    verificationId,
    verificationCode
  };
}

export function setFirebaseMfaVerificationProps({ resolver, verificationId, phoneNumber }) {
  return {
    type: authTypes.FIREBASE_MFA_SET_VERIFICATION_PROPS,
    resolver,
    verificationId,
    phoneNumber
  };
}

export function actionFirebaseMfaSuccess({ userCredential, isNewUser }) {
  return {
    type: authTypes.FIREBASE_MFA_SUCCESS,
    userCredential,
    isNewUser
  };
}

export function actionFirebaseLoginSuccess({ userCredential, isNewUser }) {
  return {
    type: authTypes.FIREBASE_LOGIN_SUCCESS,
    userCredential,
    isNewUser
  };
}

export function actionFirebaseAddPhoneNumber({ userCredential }) {
  return {
    type: authTypes.FIREBASE_ADD_PHONE_NUMBER,
    userCredential
  };
}

export function setModal(modal) {
  return {
    type: authTypes.AUTH_SET_MODAL,
    modal
  };
}

export const setFirebaseAuthMobileState = ({ email, idToken }) => ({
  type: authTypes.AUTH_SET_FIREBASE_AUTH_MOBILE_STATE,
  email,
  idToken
});

export const verifyLoginMobile = ({ email, idToken }) => ({
  type: authTypes.AUTH_VERIFY_LOGIN_MOBILE,
  email,
  idToken
});

export const setReferrals = ({ referralCode, cardPartnershipCode }) => ({
  type: authTypes.SET_REFERRALS,
  referralCode,
  cardPartnershipCode
});

export function setIsEnrollFirebaseSms2faOnSignup(value) {
  return {
    type: authTypes.AUTH_SET_IS_ENROLL_FIREBASE_SMS_2FA_ON_SIGNUP,
    value
  };
}
